import React from 'react';
import {
  Grid,
  Typography,
  IconButton,
  Box,
  FormHelperText,
} from '@material-ui/core';
import { DURATION_OPTIONS } from 'constants/forms';
import { MediaType, SelectEvent } from 'models/forms';
import { AudioOptionInput, MediaFile } from 'models';
import { isDuplicated } from 'helpers/arrays';
import CancelIcon from '@material-ui/icons/Cancel';
import Select from 'components/form/Select';
import MediaUploader from 'components/form/MediaUploader';
import useStyles from './style';

interface Props {
  option: number;
  values: AudioOptionInput;
  selectedDurations: number[];
  onChange: (option: number, values: AudioOptionInput) => void;
  onDelete: (option: number) => void;
}

const AddNewProgramForm: React.FC<Props> = (props) => {
  const { option, values, selectedDurations, onChange, onDelete } = props;
  const classes = useStyles();
  const isDurationDuplicated = values.duration
    ? isDuplicated(values.duration, selectedDurations)
    : false;

  const handleDurationSelect = (event: SelectEvent): void => {
    onChange(option, { ...values, duration: event.target.value as number });
  };

  const handleHeadphonesAudioUpload = (file: MediaFile): void => {
    onChange(option, { ...values, audioTrack: file });
  };

  const handleWristbandAudioUpload = (file: MediaFile): void => {
    onChange(option, { ...values, padsTrack: file });
  };

  const handleDelete = (): void => {
    onDelete(option);
  };

  return (
    <div className={classes.container}>
      <Typography variant='body1' className={classes.title}>
        {`Option ${option + 1}`}
      </Typography>
      <Grid container className={classes.options}>
        <Grid item xs={12} sm={4}>
          <Typography variant='body2' className={classes.subTitle}>
            Headphone (Stereo)
          </Typography>
          <MediaUploader
            id={`${option}-headphone-input`}
            buttonText='Upload Audio'
            mediaType={MediaType.AUDIO}
            file={values.audioTrack}
            onChange={handleHeadphonesAudioUpload}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography variant='body2' className={classes.subTitle}>
            Wristband (Mono)
          </Typography>
          <MediaUploader
            id={`${option}-wristband-input`}
            buttonText='Upload Audio'
            mediaType={MediaType.AUDIO}
            file={values.padsTrack}
            onChange={handleWristbandAudioUpload}
          />
        </Grid>
        <Grid item xs={12} sm={4} className={classes.durationArea}>
          <Box className={classes.durationSelect}>
            <Typography variant='body2' className={classes.subTitle}>
              Duration (Minutes)
            </Typography>
            <Select
              id={`${option}-duration-id`}
              name={`${option}-duration-name`}
              value={values.duration}
              options={DURATION_OPTIONS}
              onChange={handleDurationSelect}
            />
            {isDurationDuplicated && (
              <FormHelperText className={classes.error}>
                * Duplicated
              </FormHelperText>
            )}
          </Box>
          {option !== 0 && (
            <IconButton
              color='primary'
              aria-label='Delete picture'
              component='span'
              onClick={handleDelete}
            >
              <CancelIcon />
            </IconButton>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default AddNewProgramForm;
